import { Service } from '../mainService'

const pcaService = {
    listarPCAs,
    removeFile,
    viewFile,
    getPrestacao,
    sendFile,
    carregarRelatorioSugerido,
    cancelarAguardandoAssinatura,
    prepararParaAssinatura,
}

async function listarPCAs() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCA/listarPCAs");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function removeFile(codArquivo, newIdPrestacaoConta) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_ENTREGAS_API + "/PCA/exclusaoarquivo/" + newIdPrestacaoConta + "/" + codArquivo);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function viewFile(codArquivo, newIdPrestacaoConta) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCA/gerarArquivo/" + newIdPrestacaoConta + "/" + codArquivo);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function getPrestacao(idPrestacaoConta) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCA/statuspca/" + (typeof (idPrestacaoConta) !== 'undefined' ? idPrestacaoConta : ''));
        return response;
    } catch (e) {
        return e.response;
    }
}

async function sendFile(tipoArquivo, data, onUploadProgress, newIdPrestacaoConta) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_ENTREGAS_API + "/PCA/envioarquivo/" + newIdPrestacaoConta + "/" + tipoArquivo, data, { onUploadProgress: onUploadProgress });
        return response;
    } catch (e) {
        return e.response;
    }
}

async function carregarRelatorioSugerido(idPCA, idTaatu) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_ENTREGAS_API + "/PCA/carregarSugerido/" + idPCA + "/" + idTaatu);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function cancelarAguardandoAssinatura() {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_ENTREGAS_API + "/PCA/cancelarAguardandoAssinatura");
        return response;
    } catch (e) {
        return e.response;
    }
}

async function prepararParaAssinatura(idPCA) {
    try {
        const form = new FormData()
        form.append('idPCA', idPCA)
        const response = await Service.$http.post(process.env.VUE_APP_ENTREGAS_API + "/PCA/prepararPdfAssinar/" + idPCA, form);
        return response;
    } catch (e) {
        return e.response;
    }
}

export default pcaService;